$(document).ready(function ($) {
	swiperInit();
	home2HoverItem();
	home5HoverItem();
	moveBreadcrumb();
	About.init();
	Product.init();
	setTimeout(() => {
		$(".loading-screen").addClass("active");
	}, 100);
	TitleToggleSupport();
	ClickExpandSidebar();
	header.init();
	AppendFormProduct();
	InfinitieScrollPagination();
	AccountInfo.init();
	customButtonDownload();
	cmsAdminPannel();
	ButtonToTop();
	clickScrollDownSection();
	formatNumberCurrency();
	wrapToggleFabric();
	handleLibrary();
	Fancybox.defaults.parentEl = document.getElementById("aspnetForm");
	// zoomImg();
});

function zoomImg() {
	const vw = $(window).width();
	$(".zoom-img-ez").ezPlus({
		scrollZoom: true,
		zoomWindowWidth: vw < 768 ? 200 : 350,
		zoomWindowHeight: vw < 768 ? 200 : 350,
	});
	console.log("refresh");
}

/*====================  ====================*/

function wrapToggleFabric() {
	$(".wrap-item-fabric").each(function () {
		const $this = $(this);
		const heightInit = $(this).find(".content > p:first").height();
		const heightOrigin = $(this).find(".content").height();
		const buttonToggle = $(this).find(".button-read-more");
		$this.find(".wrap-content-toggle").css("height", heightInit);
		buttonToggle.on("click", function () {
			if (!$this.hasClass("active")) {
				$this.find(".wrap-content-toggle").css("height", heightOrigin);
				$this
					.find(".button-read-more")
					.find("span")
					.text($("body").hasClass("en-us") ? "Close" : "Đóng");
			} else {
				$this.find(".wrap-content-toggle").css("height", heightInit);
				$this
					.find(".button-read-more")
					.find("span")
					.text($("body").hasClass("en-us") ? "Read more" : "Xem thêm");
			}
			$this.toggleClass("active");
		});
	});
}

function clickScrollDownSection() {
	$(".arrow-down-circle").on("click", function () {
		$("html, body").animate(
			{
				scrollTop:
					$(".section-home-2").offset().top - $("header").outerHeight(),
			},
			800
		);
	});
}
/*====================  ====================*/
function ButtonToTop() {
	let windowHeight = $(window).height();
	$(document).on("scroll", function () {
		let scrollTop = $(window).scrollTop();
		let documentHeight = $(document).height();
		if (scrollTop + windowHeight > documentHeight - windowHeight) {
			$(".button-to-top").addClass("active");
		} else {
			$(".button-to-top").removeClass("active");
		}
	});
	$(document).on("click", ".button-to-top", function () {
		$("html, body").animate({ scrollTop: 0 });
	});
}
/*====================  ====================*/
function cmsAdminPannel() {
	$(".cmsadminpanel .nav:not(.listmenu)").on("click", function () {
		$(this).closest(".cmsadminpanel").toggleClass("active");
		$(".cmsadminpanel .listmenu").toggleClass("active");
	});
}
/*====================  ====================*/
function customButtonDownload() {
	//We add the function in Global Defaults so that all flipbooks in the page act same.
	var TitlePopup;
	$("div[data-popup-catalogue-title]").on("click", function () {
		let title = $(this).data("popup-catalogue-title");
		TitlePopup = title;
	});
	// $("body").on(
	// 	"click",
	// 	".df-lightbox-close.df-ui-btn.ti-close",
	// 	function () {
	// 		setTimeout(() => {
	// 			$(".df-container").html('');
	// 			console.log('clear')
	// 		}, 1000);
	// 	}
	// );
	// DFLIP.defaults.onReady = function (flipbook) {
	// 	var customButton = jQuery(
	// 		`<a href="${flipbook.contentSource}" class="btn btn-root btn-buy-now" download>Download E-catalogue</a>`
	// 	);
	// 	flipbook.ui.more.after(customButton);
	// 	var title = jQuery(`<div class="title-40px">${TitlePopup}</div>`);
	// 	flipbook.ui.altPrev.before(title);
	// };
}
let AccountInfo = {
	checkTypeAddress: function () {
		$(".address-col .type").each(function () {
			let text = $(this).text().replace(/\s+/g, "");
			console.log("🚀 ~ file: main.js ~ line 25 ~ text", text);
			if (!text) {
				$(this).remove();
			}
		});
	},
	ToggleMobileSidebar: function () {
		$(
			'<div class="button-account-profile"><p class="title-main">Thông tin tài khoản</p> <em class="fa-light fa-chevron-up"></em></div>'
		).insertBefore(".user-sidelink");
		if ($(window).width() < 1024) {
			$(".button-account-profile").click(function (e) {
				e.preventDefault();
				$(this).toggleClass("active");
				$(".user-sidelink").toggleClass("active");
			});
		}
	},
	init: function () {
		AccountInfo.ToggleMobileSidebar();
		AccountInfo.checkTypeAddress();
	},
};
/*==================== Infinitie Scroll Pagination ====================*/
function InfinitieScrollPagination() {
	if (!$(".ModulePager").length) {
		$(".button-add-more-product").remove();
	}
	if (!$(".ModulePager").length) return;
	let infScrollProduct = $(".wrap-item-append").infiniteScroll({
		path: ".ModulePager",
		append: ".item-pagination-ajax",
		status: ".scroller-status",
		hideNav: ".pagination",
		button: ".button-add-more-product",
		checkLastPage: ".LastPage",
		history: "push",
		scrollThreshold: false,
	});
	infScrollProduct.on(
		"append.infiniteScroll",
		function (event, body, path, items, response) {
			lozad().observe();
			wrapToggleFabric();
			console.log(`Appended ${items.length} items on ${path}`);
		}
	);
}
/*==================== Function Append Form Product ====================*/
function AppendFormProduct() {
	let title = $(".title-product-form").text();
	$(".text-product-in-form input").val(title);
	if ($(".append-form-contact").length) {
		$(".wrap-form-main").appendTo(".append-form-contact");
	}
}
/*==================== Function Click Expand Sidebar ====================*/
function ClickExpandSidebar() {
	$(".sidebar-fixed .tools-bar").on("click", function () {
		$(this).toggleClass("active");
		$(this).closest(".sidebar-fixed").toggleClass("active");
	});
}
/*==================== Toggle Support ====================*/
function TitleToggleSupport() {
	$(".item-toggle-support .title").on("click", function () {
		$(this)
			.closest(".item-toggle-support")
			.toggleClass("active")
			.find(".content")
			.slideToggle()
			.closest(".item-toggle-support")
			.siblings()
			.removeClass("active")
			.find(".content")
			.slideUp();
	});
}
function formatNumberCurrency(params) {
	$(".format-price").each(function () {
		formatCurrency($(this));
	});
	function formatNumber(n) {
		// format number 1000000 to 1,234,567
		return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	}
	function formatCurrency(input) {
		// appends $ to value, validates decimal side
		// and puts cursor back in right position.

		// get input value
		var input_val = input.val();

		// don't validate empty input
		if (input_val === "") {
			return;
		}

		// original length
		var original_len = input_val.length;

		// initial caret position
		var caret_pos = input.prop("selectionStart");

		// check for decimal
		input_val = formatNumber(input_val);
		input_val = input_val + " đ";

		// send updated string to input
		input.val(input_val);

		// Get value

		// put caret back in the right position
		var updated_len = input_val.length;
		caret_pos = updated_len - original_len + caret_pos;
		input[0].setSelectionRange(caret_pos, caret_pos);
	}
}
/*====================  ====================*/
let Product = {
	clickTabMenu: function () {
		$(".wrap-title-tab li a").on("click", function () {
			$(this).parent().addClass("active").siblings().removeClass("active");
		});
	},
	cartFlyOut: function () {
		$("body").on("click", ".wrap-cart .cart", function () {
			$("body").addClass("disable");
			$(this).closest(".wrap-cart").addClass("active");
		});
		$(".overlay-blur-cart").on("click", function () {
			removeCartPopup();
		});
		function removeCartPopup() {
			$(".wrap-cart").removeClass("active");
			$("body").removeClass("disable");
		}
		detectCloseElement($(".wrap-cart"), removeCartPopup);
	},
	productToggle: function () {
		$(".item-toggle-content .title").on("click", function () {
			$(this).toggleClass("active");
			$(this).next().slideToggle();
		});
	},
	s: function () {
		$(".list-material li a").on("click", function () {
			let index = $(this).data("index");
			$(this)
				.toggleClass("active")
				.parent()
				.siblings()
				.find("a")
				.removeClass("active");
			$(`.wrap-list-fabric .list-fabric[data-index=${index}]`)
				.slideDown()
				.siblings()
				.slideUp();
			// zoomImg();
		});
	},
	productFilter: function () {
		$(".open-filter-mobile").on("click", function () {
			$(".product-sidebar").addClass("active");
		});
		$(".product-sidebar .close").on("click", function () {
			$(".product-sidebar").removeClass("active");
		});

		$("body").on("click", ".color-filter-product li a", function () {
			$(this)
				.toggleClass("active")
				.parent()
				.siblings()
				.find("a")
				.removeClass("active");
		});

		$("body").on("click", ".filter-product-option li a", function () {
			$(this)
				.toggleClass("active")
				.parent()
				.siblings()
				.find("a")
				.removeClass("active");
		});
		$(".item-filter-product .title-filter-product").on("click", function () {
			$(this).toggleClass("active");
			$(this).next().slideToggle();
		});
		let numberLinkFliter = $(
			".content-filter-product .menu-filter-product li, .content-filter-product .filter-product-option li"
		).length;
		if (numberLinkFliter <= 8) return;
		let initHeightMenuFilter =
			$(
				".content-filter-product .menu-filter-product li, .content-filter-product .filter-product-option li"
			).outerHeight() * 8;
		$(".content-filter-product .wrap").css("height", initHeightMenuFilter);
		$("body").on("click", ".wrap-filter-main .button-view-more", function () {
			let originalMenuFilter = $(this)
				.closest(".wrap-filter-main")
				.find(".wrap ul")
				.outerHeight();
			if ($(this).closest(".wrap-filter-main").hasClass("active")) {
				$(this).closest(".wrap-filter-main").removeClass("active");
				$(this)
					.closest(".wrap-filter-main")
					.find(".wrap")
					.css("height", initHeightMenuFilter);
				$(this)
					.find("span")
					.text($("body").hasClass("en-us") ? "See more" : "Xem thêm");
			} else {
				$(this).closest(".wrap-filter-main").addClass("active");
				$(this)
					.closest(".wrap-filter-main")
					.find(".wrap")
					.css("height", originalMenuFilter);
				$(this)
					.find("span")
					.text($("body").hasClass("en-us") ? "Compact" : "Rút gọn");
			}
		});
		$(".item-filter-child .title").on("click", function () {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});
	},
	init: function () {
		console.log("Run Product Init");
		this.productFilter();
		this.cartFlyOut();
		this.productToggle();
		this.clickTabMenu();
		this.s();
	},
};
let About = {
	clickToggle: function () {
		$(".item-toggle").on("click", function () {
			$(this).toggleClass("active").siblings().removeClass("active");
			$(this)
				.find(".content")
				.slideToggle()
				.closest(".item-toggle")
				.siblings()
				.find(".content")
				.slideUp();
			$(this)
				.next()
				.toggleClass("hidden-border")
				.siblings()
				.removeClass("hidden-border");
		});
	},
	init: function () {
		About.clickToggle();
	},
};
/*====================  ====================*/
function cickTab() {
	$(".tab").on("click", function () {
		$(this).addClass("active").siblings().removeClass("active");
	});
}
/*==================== Move Breadcrumb ====================*/
function moveBreadcrumb() {
	if (!$(".global-breadcrumb-banner").length) return;
	$(".global-breadcrumb").appendTo(".global-breadcrumb-banner .wrap-title");
}
/*==================== Home 5 ====================*/
function home5HoverItem() {
	$(".item-content-main").hover(function () {
		let name = $(this).data("image");
		$(`.${name}`).addClass("active").siblings().removeClass("active");
	});
}
/*==================== Home 2 Hover Item ====================*/
function home2HoverItem() {
	$(".item-box-content").hover(
		function () {
			let imageTarget = $(this).data("image");
			$(`.${imageTarget}`).addClass("active").siblings().removeClass("active");
		},
		function () {
			$(".section-home-2 .image-1")
				.addClass("active")
				.siblings()
				.removeClass("active");
		}
	);
}
/*==================== Animation loader  ====================*/
function animationLoader(e) {
	$("body").addClass("loaded");
}
/*==================== Set background ====================*/
function setBackgroundElement() {
	$("[setbackground]").each(function () {
		var background = $(this).attr("setbackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "no-repeat",
			"background-size": "cover",
		});
	});
}
/*==================== JS Other ====================*/
function totalLengthSlide(nodeTotal, nodeCurrent, nodeSlide) {
	// console.log(nodeSlide);
	nodeTotal.text(nodeSlide.slides.length);
	nodeCurrent.text(nodeSlide.realIndex + 1);
}
function navigationSlide(nodeParent, nodePrev, nodeNext, nodeSlide) {
	nodeSlide.on("slideChange", function () {
		let indexSlide = this.activeIndex;
		let totalSlide = this.slides.length - 1;
		const nodeTotal = jQuery(nodeParent).find(".total");
		const nodeCurrent = jQuery(nodeParent).find(".current");
		totalLengthSlide(nodeTotal, nodeCurrent, this);
	});
	var totalSlide = nodeSlide.slides.length;
	var $this = nodeSlide;
	nodePrev.click(function () {
		if ($this.isBeginning) {
			$this.slideTo(totalSlide - 1);
		} else {
			$this.slideTo($this.realIndex - 1);
		}
	});
	nodeNext.click(function () {
		if ($this.isEnd) {
			$this.slideTo(0);
		} else {
			$this.slideTo($this.realIndex + 1);
		}
	});
}
let header = {
	headerPadding: function () {
		if ($(".global-breadcrumb-banner").length || $(".homepage").length) return;
		setTimeout(() => {
			$("header").addClass("noBanner");
			let heightHeader = $("header").outerHeight();
			$("main").css("padding-top", heightHeader);
		}, 0);
	},
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	megaMenu: function () {
		if ($(window).width() < 1024) return;
		function removeMegaMenu() {
			$("header").removeClass("show-mega");
			$(".dropdown-menu-product").removeClass("active");
			$(".overlay-blur").removeClass("active");
		}
		$("header .header-menu > li.many-products > a").on("click", function () {
			$("header").addClass("show-mega");
			$(".overlay-blur").addClass("active");
			// Cần check làm sao để phân biệt thằng đang click là thằng vừa rồi hay là thằng mới
			if (
				$(this).find(".dropdown-menu-product.active").length >= 0 &&
				!$(this).parent().find(".dropdown-menu-product").hasClass("active")
			) {
				$(".dropdown-menu-product").removeClass("active");
			}
			if ($(this).parent().find(".dropdown-menu-product").hasClass("active")) {
				removeMegaMenu();
			} else {
				$(this).parent().find(".dropdown-menu-product").addClass("active");
			}
			// $(this).parent().find(".dropdown-menu-product").addClass("active").parent().siblings().find('.dropdown-menu-product').removeClass('active');
			return false;
		});

		$(".overlay-blur").on("click", function (e) {
			removeMegaMenu();
		});
		$(document).keyup(function (e) {
			if (e.key === "Escape") {
				removeMegaMenu();
			}
		});
		$(document).on("scroll", function () {
			if (!$("header").hasClass("show-mega")) return;
			removeMegaMenu();
		});
	},
	search: function () {
		const container = $(".wrap-form-search-product");
		const iconSearch = $(".header-search");
		function closeSearch() {
			$(".header-search-form").removeClass("active");
			$("body").removeClass("disable");
		}
		$(document).on("click", function (e) {
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				!iconSearch.is(e.target) &&
				iconSearch.has(e.target).length === 0
			) {
				$(".header-search-form").removeClass("active");
			}
		});
		$(".header-search").on("click", function () {
			$(".header-search-form").addClass("active");
			$("body").addClass("disable");
			setTimeout(() => {
				$(".header-search-form .searchinput").focus();
			}, 400);
		});
		detectCloseElement($(".header-search-form"), closeSearch);
	},
	toolsMobile: function () {
		// .header-search,.header-account,.header-cart
		if ($(window).width() >= 1024) return;
		$(".header-search").appendTo(".header-tools-mobile");
		$(".header-account").appendTo(".header-tools-mobile");
		$(".header-cart").appendTo(".header-tools-mobile");
	},
	hambuger: function () {
		if ($(window).width() >= 1024) return;
		function removeMenuMobile() {
			$(".header-hambuger").removeClass("active");
			$(".header-menu-mobile").removeClass("active");
			$(".overlay-blur").removeClass("active");
			$("header").removeClass("hide");
			$(".header-tools-mobile").removeClass("hide");
		}
		$(".overlay-blur").on("click", function () {
			removeMenuMobile();
		});
		$(".header-menu-mobile .close").on("click", function () {
			if ($(this).hasClass("sub-category-child")) {
				$(".sub-menu-product").removeClass("active");
				$(".header-menu-mobile .close").removeClass("sub-category-child");
				return;
			}
			if ($(this).hasClass("sub-category")) {
				$(".dropdown-menu-product").removeClass("active");
				$(".header-menu-mobile .close").removeClass("sub-category");
				return;
			}
			removeMenuMobile();
		});
		$(".header-hambuger").on("click", function () {
			$(this).addClass("active");
			$(".header-menu-mobile").addClass("active");
			$(".overlay-blur").addClass("active");
			$("header").addClass("hide");
			$(".header-tools-mobile").addClass("hide");
		});
	},
	menuMobile: function () {
		if ($(window).width() >= 1024) return;
		//
		$(".header-menu").appendTo(".header-menu-mobile .bottom");
		$(".header-menu-mobile .header-menu > li.many-products > a").on(
			"click",
			function () {
				$(".header-menu-mobile .close").addClass("sub-category");
				$(this)
					.next()
					.addClass("active")
					.parent()
					.siblings()
					.find(".dropdown-menu-product")
					.removeClass("active");
				return false;
			}
		);
		$(
			".header-menu-mobile .header-menu .box-parent-category > ul > li.many-products > a"
		).on("click", function () {
			$(".header-menu-mobile .close").addClass("sub-category-child");
			$(this)
				.next()
				.addClass("active")
				.parent()
				.siblings()
				.find(".dropdown-menu-product")
				.removeClass("active");
			return false;
		});
	},
	init: function () {
		header.megaMenu();
		header.search();
		header.toolsMobile();
		header.hambuger();
		header.menuMobile();
		header.headerPadding();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
/*==================== Function Detect Close ====================*/
function detectCloseElement(ele, funcRemove) {
	// close
	$("body").on("click", ".close", function () {
		funcRemove();
	});
	// esc
	$(".overlay-blur").on("click", function () {
		funcRemove();
	});
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			funcRemove();
		}
	});
	// overlay-blur
}
/*==================== Swiper ====================*/
function swiperInit() {
	var SectionSlideHome = new Swiper(".section-home-1 .swiper", {
		spaceBetween: 10,
		speed: 1000,
		slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: true,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		speed: 1000,
		pagination: {
			el: ".section-home-1 .swiper-pagination",
			clickable: true,
		},
		on: {
			init: function () {
				const nodeTotal = jQuery(".section-home-1 .total");
				const nodeCurrent = jQuery(".section-home-1 .current");
				const nodeSlide = this;
				totalLengthSlide(nodeTotal, nodeCurrent, nodeSlide);
			},
		},
	});
	navigationSlide(
		$(".section-home-1"),
		$(".section-home-1 .btn-prev"),
		$(".section-home-1 .btn-next"),
		SectionSlideHome
	);
	var ItemHome2 = new Swiper(".section-home-2 .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		pagination: {
			el: ".section-home-2 .wrap-slide-mobile .swiper-pagination",
			type: "bullets",
		},
	});
	var home3 = new Swiper(".section-home-3 .swiper", {
		slidesPerView: 1.5,
		spaceBetween: 15,
		pagination: {
			el: ".section-home-3 .swiper-pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: ".section-home-3 .btn-next",
			prevEl: ".section-home-3 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4.25,
				spaceBetween: 30,
			},
		},
	});
	var ItemCategory = new Swiper(".swiper-item-category", {
		slidesPerView: 4,
		spaceBetween: 15,
		navigation: {
			nextEl: ".section-home-3 .btn-next",
			prevEl: ".section-home-3 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 80,
			},
		},
	});
	var ItemHome6 = new Swiper(".section-home-6 .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		navigation: {
			nextEl: ".section-home-6 .btn-next",
			prevEl: ".section-home-6 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
	var ItemHome7 = new Swiper(".section-home-7 .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		autoplay: {
			delay: 3500,
		},
		navigation: {
			nextEl: ".section-home-7 .btn-next",
			prevEl: ".section-home-7 .btn-prev",
		},
		pagination: {
			el: ".section-home-7 .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
		},
	});
	var About5 = new Swiper(".section-about-5 .swiper", {
		slidesPerView: 2,
		spaceBetween: 15,
		navigation: {
			nextEl: ".section-about-5 .btn-next",
			prevEl: ".section-about-5 .btn-prev",
		},
		breakpoints: {
			1024: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
		},
	});
	var ProductCollections = new Swiper(".section-wrap-collections .swiper", {
		slidesPerView: 1.5,
		spaceBetween: 15,
		pagination: {
			el: ".section-wrap-collections .swiper-pagination",
			type: "progressbar",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 2.25,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 3.38,
				spaceBetween: 30,
			},
		},
	});
	$(".wrap-section-product-processbar").each(function (index) {
		const name = `product-processbar-${index}`;
		$(this).addClass(name);
		new Swiper(`.${name} .swiper`, {
			slidesPerView: 1.5,
			spaceBetween: 15,
			pagination: {
				el: `.${name} .swiper-pagination`,
				type: "progressbar",
			},
			navigation: {
				nextEl: `.${name} .btn-next`,
				prevEl: `.${name} .btn-prev`,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1280: {
					slidesPerView: 4.25,
					spaceBetween: 30,
				},
			},
		});
	});
	var ProductBrandsThumb = new Swiper(
		".section-product-brand .img-thumb .swiper",
		{
			slidesPerView: 3,
			spaceBetween: 8,
			breakpoints: {
				768: {
					direction: "vertical",
					spaceBetween: 10,
					slidesPerView: 4,
				},
				1280: {
					slidesPerView: 5,
					direction: "vertical",
					spaceBetween: 10,
				},
			},
		}
	);
	var ProductBrands = new Swiper(".section-product-brand .img-main .swiper", {
		slidesPerView: 1,
		spaceBetween: 15,
		navigation: {
			nextEl: `.section-product-brand .btn-next`,
			prevEl: `.section-product-brand .btn-prev`,
		},
		thumbs: {
			swiper: ProductBrandsThumb,
		},
	});
	$(".item-number-step").on("click", function () {
		$(this).addClass("active").siblings().removeClass("active");
		let index = $(this).data("number");
		SlideProcess.slideTo(index);
	});
	var SlideProcess = new Swiper(".swiper-process-step", {
		slidesPerView: 1,
		spaceBetween: 15,
		speed: 1000,
		navigation: {
			nextEl: `.swiper-process-step .btn-next`,
			prevEl: `.swiper-process-step .btn-prev`,
		},
		on: {
			slideChange: function () {
				let number = this.realIndex;
				$(".item-number-step")
					.eq(number)
					.addClass("active")
					.siblings()
					.removeClass("active");
				console.log(this.realIndex);
			},
		},
	});
	var About5 = new Swiper(".section-service-customer .swiper", {
		slidesPerView: 2,
		spaceBetween: 0,
		navigation: {
			nextEl: ".section-service-customer .btn-next",
			prevEl: ".section-service-customer .btn-prev",
		},
		breakpoints: {
			1024: {
				slidesPerView: 4,
				spaceBetween: 0,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 0,
			},
		},
		grid: {
			rows: 2,
		},
	});

	var libraryThumb = new Swiper(".thu-vien-anh-ct .swiper-thumb .swiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: ".thu-vien-anh-ct .btn-next",
			prevEl: ".thu-vien-anh-ct .btn-prev",
		},
		pagination: {
			el: ".thu-vien-anh-ct .swiper-thumb .swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3.3,
				direction: "vertical",
				grid: {
					fill: "row",
				},
			},
		},
	});
}

function handleLibrary(){
	var libraryMain = new Swiper(".thu-vien-anh-ct .swiper-main .swiper", {
		slidesPerView: 1,
	});

	$('.thu-vien-anh-ct .swiper-thumb .box-img').each(function(index){
		$(this).attr('data-thumb', index);
	})

	$('body').on('click', '.thu-vien-anh-ct .swiper-thumb .box-img', function(){
		let idx = $(this).attr('data-thumb');
		libraryMain.slideTo(idx)
	})
}
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
